import { Injectable } from "@angular/core";
import { Actions } from "@ngrx/effects";


@Injectable()
export class GlobalLayoutEffects {
  constructor(
    private actions$: Actions) { }
}
